export default __webpack_public_path__ + "images/tequila-sunrise-small.png";